import * as React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { compose } from 'redux';

import PlaceholderCard from 'af-root/scenes/Company/ScheduleBoard/Shared/Card/PlaceholderCard';

import type { RootState } from 'af-reducers';

import { REMOVE_BLANK_WORK_ORDER } from 'af-constants/reduxForms';

interface OwnProps {
	index: number;
	draggableId?: string;
	dueDate?: string;
	isDragAndDropDisabled: boolean;
	hasPermissionsToEditScheduleBoard: boolean;
	isPlaceholder?: boolean;
	removeBlankWorkOrder?: (dueDate: string, index: number) => Promise<void>;
}

type Props = OwnProps & ConnectedProps<typeof connector>;

const BlankCard: React.FC<Props> = (props) => {
	const {
		removeBlankWorkOrder,
		dueDate,
		index,
		removeEnabled,
		isDragAndDropDisabled = false,
		hasPermissionsToEditScheduleBoard = true,
		draggableId,
		isPlaceholder = false,
	} = props;

	const removeBlankColumn = React.useCallback(async () => {

		if (!removeEnabled || !dueDate || !removeBlankWorkOrder) {
			return;
		}
		await removeBlankWorkOrder(dueDate, index);
	}, [dueDate, index, removeBlankWorkOrder, removeEnabled]);

	return (
		<div className="schedule-board-card-wrapper">
			<div
				className={`schedule-board-arrow-index-container ${removeEnabled ? 'pointer' : ''}`}
				onClick={removeBlankColumn}
			>
				<div className="schedule-board-card-index">{index + 1}</div>
			</div>
			{
				(isDragAndDropDisabled || !hasPermissionsToEditScheduleBoard) ?
					(
						isPlaceholder && <PlaceholderCard />
					) : (
						<Draggable
							draggableId={draggableId ?? `${index}`} // Irrelevant draggable ID but we need to define it
							index={index}
							isDragDisabled={true}
						>
							{
								(provided) => {
									return (
										<div
											className={`${isPlaceholder ? 'schedule-board-card' : 'blank-card'}`}
											ref={provided.innerRef}
											{...provided.draggableProps}
											{...provided.dragHandleProps}
										>
											{isPlaceholder && <PlaceholderCard />}
										</div>
									);
								}
							}
						</Draggable>
					)}
		</div>
	);
};

function mapStateToProps(state: RootState, ownProps: OwnProps) {
	const { isDragAndDropDisabled, hasPermissionsToEditScheduleBoard, isPlaceholder } = ownProps;
	const readOnly = isDragAndDropDisabled || !hasPermissionsToEditScheduleBoard;

	return {
		removeEnabled: !readOnly && !isPlaceholder && !state.http.submitting.includes(REMOVE_BLANK_WORK_ORDER),
	};
}

const connector = connect(mapStateToProps);

const enhance = compose<React.ComponentType<OwnProps>>(
	React.memo,
	connector
);

export default enhance(BlankCard);
